import { createActions, createReducer } from 'reduxsauce';
import { CHECKIN_STATUS } from '../constant';
import { message } from 'antd';

// Define Action
const { Types, Creators } = createActions({
  getCheckinList: ['id'],
  getCheckinDataSuccess: ['data'],
  checkinPolling: null,
  checkinTabChange: ['tabName'],
  checkinNext: null,
  closeCheckin: null,
  closeCheckinSuccess: ['data'],
  restore: null,
  getCheckinQrcodeUrl: null,
  getCheckinQrcodeUrlSuccess: ['data'],
  rejectSignLeavel: ['studentMemberId', 'refusalReason'],
  rejectSignLeavelSuccess: ['data'],
  switchSignType: ['signType'],
  switchSignTypeSuccess: null,
});

export const Creator = Creators;
export const Type = Types;

// Define Initial State
const DEFAULT_PAGEING_SIZE = 20;
const INITIAL_STATE = {
  serverTime: null,
  signClosedTime: null,
  signEndTime: null,
  pageIndex: 1,
  pageSize: DEFAULT_PAGEING_SIZE,
  checkinData: [],
  pagingData: {},
  statisticData: [],
  signinStatus: CHECKIN_STATUS.CHECKED,
  signinSumAbsent: 0,
  totalMemberNum: 0,
  signinSumSignin: 0,
  signinSumLate: 0,
  signinSumSickLeave: 0,
  signinSumLeave: 0,
  closeCheckinAction: false,
  rejectReasonModalCloseFlag: 0,
  // 签到类型
  signType: 0,
  // 二维码的url
  qrCodeUrl: '',
};
// Define Reducer
export default createReducer(INITIAL_STATE, {
  [Type.GET_CHECKIN_DATA_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    serverTime: action.data?.serverTime ?? null,
    signClosedTime: action.data?.signinDto?.signClosedTime ?? null,
    signEndTime: action.data?.signinDto?.signEndTime ?? null,
    signinSumAbsent: action.data?.signinDto?.signinSumAbsent ?? 0,
    totalMemberNum: action.data?.signinDto?.totalMemberNum ?? 0,
    signinSumSignin: action.data?.signinDto?.signinSumSignin ?? 0,
    signinSumLate: action.data?.signinDto?.signinSumLate ?? 0,
    signinSumSickLeave: action.data?.signinDto?.signinSumSickLeave ?? 0,
    signinSumLeave: action.data?.signinDto?.signinSumLeave ?? 0,
    statisticData: action.data?.signinDto ?? {},
    pagingData: action.data?.paginationResult?.query ?? {},
    checkinData: action.data?.paginationResult?.list ?? [],
    // 获取签到类型
    signType: action.data?.signinDto?.signType ?? 0,
    pageSize:
      (action.data?.paginationResult?.query?.totleCount ?? 1) >
      (action.data?.paginationResult?.query?.pageSize ?? DEFAULT_PAGEING_SIZE)
        ? action.data?.paginationResult?.query?.pageSize ?? DEFAULT_PAGEING_SIZE
        : (action.data?.paginationResult?.query?.totlePageCount ?? 1) *
          DEFAULT_PAGEING_SIZE,
  }),
  [Type.CHECKIN_TAB_CHANGE]: (state = INITIAL_STATE, action) => ({
    ...state,
    pageIndex: 1,
    pageSize: DEFAULT_PAGEING_SIZE,
    signinStatus: action.tabName,
  }),
  [Type.CHECKIN_NEXT]: (state = INITIAL_STATE) => ({
    ...state,
    pageIndex: 1,
    pageSize:
      DEFAULT_PAGEING_SIZE * (state.pageSize / DEFAULT_PAGEING_SIZE + 1),
  }),
  [Type.CLOSE_CHECKIN_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    closeCheckinAction: true,
  }),
  [Type.RESTORE]: (state = INITIAL_STATE, action) => ({
    ...state,
    closeCheckinAction: false,
  }),
  // 获取二维码成功action
  [Type.GET_CHECKIN_QRCODE_URL_SUCCESS]: (state = INITIAL_STATE, action) => {
    // 如果url是http开头的，换成https
    return { ...state, qrCodeUrl: action.data?.replace('http', 'https') ?? '' };
  },
  [Type.REJECT_SIGN_LEAVEL_SUCCESS]: (state = INITIAL_STATE, action) => {
    if (action.data) {
      message.success('操作成功！');
      return { ...state, rejectReasonModalCloseFlag: +new Date() };
    }
    message.error('操作失败，请刷新重试！');
    return { ...state };
  },
  // 切换签到类型
  [Type.SWITCH_SIGN_TYPE_SUCCESS]: (state = INITIAL_STATE, action) => {
    return { ...state, signType: action?.signType ?? 0 };
  },
});
